import { motion } from 'framer-motion';
import { FileQuestion } from 'lucide-react';
import { DictionaryEntry } from '../types';
import { TermCard } from './TermCard';

interface TermsGridProps {
  entries: DictionaryEntry[];
  onTermClick: (entry: DictionaryEntry) => void;
  showLetterWatermark?: boolean;
}

export const TermsGrid = ({ entries, onTermClick, showLetterWatermark }: TermsGridProps) => {
  if (entries.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="text-center py-20 px-6"
      >
        <FileQuestion className="w-20 h-20 text-slate-300 mx-auto mb-6" />
        <h3 className="text-2xl font-serif font-bold text-slate-800 mb-2">
          Aucun terme trouvé
        </h3>
        <p className="text-slate-600">
          Essayez de modifier votre recherche ou vos filtres
        </p>
      </motion.div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {entries.map((entry, index) => (
        <TermCard
          key={entry.id}
          entry={entry}
          onClick={() => onTermClick(entry)}
          index={index}
          showLetterWatermark={showLetterWatermark}
        />
      ))}
    </div>
  );
};
